import axios from '../axios'
// 查询用户列表
export const getUserList = (data) => {
    return axios({
      url: '/con/account/listUser',
      method: 'POST',
      data: data
    })
}
//查看小程序列表
export const getAppUserList = (data) => {
  return axios({
    url: '/con/account/getUserList',
    method: 'POST',
    data: data
  })
}
//禁用全平台
export const updateAccountStatus = (data) => {
  return axios({
    url: '/con/account/updateAccountStatus',
    method: 'POST',
    data: data
  })
}
//禁用子平台
export const updatePlatformUserStatus = (data) => {
  return axios({
    url: '/con/account/updatePlatformUserStatus',
    method: 'POST',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/user.js